module.exports = __webpack_public_path__ + "img/Badge_NIS_2026.fb747a60.jpg";